import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { areaDe } from "../destinoPorPapel";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: "ADMIN" | "TEACHER" | "STUDENT" | "SCHOOL_STAFF";
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  // Aguarda a verificação da autenticação antes de redirecionar
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-marca-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Área de outro papel: a área inicial do papel da sessão (a troca de conta chega aqui antes da própria navegação).
  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to={areaDe(user?.role)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 